import React, { Component } from 'react'
import { renderReact } from 'hypernova-react'

// I18n
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import ru from 'react-intl/locale-data/ru'
import zh from 'react-intl/locale-data/zh'
import ja from 'react-intl/locale-data/ja'
import localeData from './locales/data'

addLocaleData([...en, ...ru, ...zh, ...ja])

// Constants
import { DEFAULT_LOCALE, CHINA_REGION } from 'components/dashboard/constants'

// Components
import Layout from './layout'
import ImpersonateApp from './impersonate/app'

class Impersonate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      flash: props.flash,
    }

    this.flashHandler = this.flashHandler.bind(this)
  }

  flashHandler(flash) {
    this.setState({ flash })
  }

  render() {
    const { intlLocale, locale, region } = this.props
    const messages = localeData[intlLocale]

    return (
      <IntlProvider locale={intlLocale} intlLocale={intlLocale} messages={messages}>
        <Layout
          locale={locale}
          intlLocale={intlLocale}
          messages={messages}
          region={region}
          resources={this.props.resources}
          flash={this.state.flash}
        >
          <ImpersonateApp
            token={this.props.token}
            locale={locale}
            region={region}
            login={this.props.login || ''}
            customer={this.props.customer || ''}
            iccid={this.props.iccid || ''}
            imsi={this.props.imsi || ''}
          />
        </Layout>
      </IntlProvider>
    )
  }
}

export default renderReact('application/impersonate', Impersonate)




// WEBPACK FOOTER //
// ./app/javascript/components/application/impersonate.js